export default "__VITE_ASSET__K565bSXf__"